<div class="teleporter">
  <ng-content></ng-content>
</div>